import { render, staticRenderFns } from "./AddressFull.vue?vue&type=template&id=252aea52"
import script from "./AddressFull.vue?vue&type=script&lang=js"
export * from "./AddressFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports